export default __webpack_public_path__ + "static/Montserrat-Bold-11263e847e4851dea50b7f0ffea006d6.woff2";